<template>
  <div class="admin-page">
    <admin-page-header
      eyebrow="Ayarlar"
      title="Hesap ayarları"
      description="Profil bilgileri, güvenlik tercihleri ve bildirim seçeneklerini aynı ayar yüzeyinden yönetin."
    />

    <v-card
      class="admin-table-card"
      outlined
    >
      <v-tabs
        v-model="activeTab"
        class="admin-tabs"
      >
        <v-tab>Profil</v-tab>
        <v-tab>Güvenlik</v-tab>
        <v-tab>Bildirimler</v-tab>
      </v-tabs>

      <v-tabs-items v-model="activeTab">
        <v-tab-item>
          <v-card-text class="pa-6">
            <div class="settings-profile">
              <div class="settings-profile__hero">
                <v-avatar
                  color="primary"
                  size="72"
                >
                  <span class="white--text text-h6 font-weight-bold">{{ initials }}</span>
                </v-avatar>

                <div class="settings-profile__copy">
                  <div class="text-h6 font-weight-bold">
                    {{ displayName }}
                  </div>
                  <div class="text-body-2 text--secondary">
                    {{ profileForm.email }}
                  </div>
                </div>
              </div>

              <v-row class="mt-4">
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="profileForm.firstName"
                    outlined
                    dense
                    label="Ad"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="profileForm.lastName"
                    outlined
                    dense
                    label="Soyad"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="profileForm.email"
                    outlined
                    dense
                    label="Email"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="profileForm.phoneNumber"
                    outlined
                    dense
                    label="Telefon"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="profileForm.birthDate"
                    outlined
                    dense
                    type="date"
                    label="Doğum Tarihi"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-select
                    v-model="profileForm.gender"
                    :items="genderOptions"
                    item-text="text"
                    item-value="value"
                    outlined
                    dense
                    label="Cinsiyet"
                  ></v-select>
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="profileForm.timezone"
                    outlined
                    dense
                    disabled
                    label="Saat dilimi"
                  ></v-text-field>
                </v-col>
              </v-row>

              <div class="d-flex justify-end mt-2">
                <v-btn
                  color="primary"
                  :loading="profileSaving"
                  @click="saveProfile"
                >
                  Profili Kaydet
                </v-btn>
              </div>
            </div>
          </v-card-text>
        </v-tab-item>

        <v-tab-item>
          <v-card-text class="pa-6">
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="securityForm.currentPassword"
                  disabled
                  outlined
                  dense
                  type="password"
                  label="Mevcut Şifre"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="securityForm.newPassword"
                  disabled
                  outlined
                  dense
                  type="password"
                  label="Yeni Şifre"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="securityForm.confirmPassword"
                  disabled
                  outlined
                  dense
                  type="password"
                  label="Yeni Şifre Tekrar"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="6"
                class="d-flex align-center"
              >
                <v-switch
                  v-model="securityForm.twoFactor"
                  disabled
                  inset
                  label="İki faktörlü doğrulama"
                ></v-switch>
              </v-col>
            </v-row>

            <v-alert
              text
              dense
              color="warning"
              class="mt-2"
            >
              Şifre değişimi ve iki faktörlü doğrulama bu panelden henüz yönetilemiyor. Bu alanlar mevcut hesap güvenliği durumunu göstermez.
            </v-alert>

            <div class="d-flex justify-end">
              <v-btn
                color="primary"
                disabled
              >
                Şifreyi Güncelle
              </v-btn>
            </div>
          </v-card-text>
        </v-tab-item>

        <v-tab-item>
          <v-card-text class="pa-6">
            <div
              v-for="item in notificationItems"
              :key="item.key"
              class="settings-notification-row"
            >
              <div>
                <div class="font-weight-medium">
                  {{ item.label }}
                </div>
                <div class="text-caption text--secondary">
                  {{ item.helper }}
                </div>
              </div>

              <v-switch
                v-model="notificationForm[item.key]"
                inset
                hide-details
                color="primary"
                class="mt-0 pt-0"
              ></v-switch>
            </div>

            <v-alert
              text
              dense
              color="info"
              class="mt-4"
            >
              Bildirim ayarları mevcut backend kontratındaki boolean alanlara göre `user/notification` üzerinden kaydedilir. Kanal bazlı ayrım ayrı bir DTO temizliği gerektiriyor.
            </v-alert>

            <div class="d-flex justify-end mt-4">
              <v-btn
                color="primary"
                :loading="notificationSaving"
                @click="saveNotifications"
              >
                Tercihleri Kaydet
              </v-btn>
            </div>
          </v-card-text>
        </v-tab-item>
      </v-tabs-items>
    </v-card>

    <v-snackbar
      v-model="snackbar"
      timeout="3200"
      :color="snackbarColor"
    >
      {{ snackbarMessage }}
    </v-snackbar>
  </div>
</template>

<script>
import axios from 'axios'
import { getAccessToken } from '@/utils/panelSession'
import AdminPageHeader from '@/components/admin/AdminPageHeader.vue'

const createDefaultProfileForm = () => ({
  firstName: 'Admin',
  lastName: 'Kullanıcı',
  email: 'panel@adverport.com',
  phoneNumber: '',
  birthDate: '',
  gender: false,
  timezone: 'Europe/Istanbul',
  appsFlyerId: '',
})

const createDefaultNotificationForm = () => ({
  newCampaign: true,
  newBrand: true,
  newConversion: true,
  newClick: true,
  newPayout: true,
  smartPush: true,
})

export default {
  name: 'AccountSettings',
  components: {
    AdminPageHeader,
  },
  data() {
    return {
      activeTab: 0,
      snackbar: false,
      snackbarColor: 'info',
      snackbarMessage: '',
      profileSaving: false,
      notificationSaving: false,
      profileForm: createDefaultProfileForm(),
      securityForm: {
        currentPassword: '',
        newPassword: '',
        confirmPassword: '',
        twoFactor: false,
      },
      notificationForm: createDefaultNotificationForm(),
      notificationItems: [
        {
          key: 'newCampaign',
          label: 'Yeni kampanya',
          helper: 'Sisteme yeni kampanya eklendiğinde bildirim gönder.',
        },
        {
          key: 'newBrand',
          label: 'Yeni marka / offer',
          helper: 'Yeni offer veya marka kaydı oluştuğunda haber ver.',
        },
        {
          key: 'newConversion',
          label: 'Yeni dönüşüm',
          helper: 'Onaylanan dönüşüm ve kazanç kayıtlarını bildir.',
        },
        {
          key: 'newClick',
          label: 'Yeni tıklama',
          helper: 'Link aktivitesi ve tıklama akışını görünür tut.',
        },
        {
          key: 'newPayout',
          label: 'Payout değişimi',
          helper: 'Ödeme ve payout hareketleri değiştiğinde bildir.',
        },
        {
          key: 'smartPush',
          label: 'Akıllı push',
          helper: 'Sistem tarafından üretilen operasyonel push bildirimleri.',
        },
      ],
      genderOptions: [
        { text: 'Erkek', value: false },
        { text: 'Kadın', value: true },
      ],
    }
  },
  computed: {
    displayName() {
      const value = [this.profileForm.firstName, this.profileForm.lastName]
        .filter(Boolean)
        .join(' ')
        .trim()

      return value || 'Admin Kullanıcı'
    },
    initials() {
      const value = this.displayName
        .split(' ')
        .filter(Boolean)
        .slice(0, 2)
        .map(part => part.charAt(0))
        .join('')
        .toUpperCase()

      return value || 'AP'
    },
  },
  mounted() {
    this.fetchSelf()
  },
  methods: {
    authHeaders() {
      const token = getAccessToken()

      return token ? { Authorization: `Bearer ${token}` } : {}
    },
    normalizeInputDate(value) {
      if (!value) return ''

      if (typeof value === 'string') {
        if (/^\d{2}\/\d{2}\/\d{4}$/.test(value)) {
          const [day, month, year] = value.split('/')

          return `${year}-${month}-${day}`
        }

        if (/^\d{4}-\d{2}-\d{2}/.test(value)) {
          return value.slice(0, 10)
        }
      }

      const date = new Date(value)
      if (Number.isNaN(date.getTime())) return ''

      return date.toISOString().slice(0, 10)
    },
    formatApiDate(value) {
      if (!value) return null

      const [year, month, day] = value.split('-')

      return `${day}/${month}/${year}`
    },
    normalizePhone(value) {
      return (value || '').replace(/^\+/, '').trim()
    },
    resolveErrorMessage(error, fallback) {
      return error?.response?.data?.message || error?.response?.data?.error || fallback
    },
    showMessage(message, color = 'info') {
      this.snackbarMessage = message
      this.snackbarColor = color
      this.snackbar = true
    },
    fetchSelf() {
      const headers = this.authHeaders()
      if (!headers.Authorization) return

      axios
        .get(`${process.env.VUE_APP_BASE_API_URL}user/self`, { headers })
        .then(response => {
          const user = response.data?.data
          if (!user) return

          this.profileForm = {
            firstName: user.name || this.profileForm.firstName,
            lastName: user.surname || this.profileForm.lastName,
            email: user.email || this.profileForm.email,
            phoneNumber: user.mobile || '',
            birthDate: this.normalizeInputDate(user.birthDate),
            gender: Boolean(user.gender),
            timezone: 'Europe/Istanbul',
            appsFlyerId: user.appsFlyerId || '',
          }

          this.notificationForm = {
            ...createDefaultNotificationForm(),
            ...(user.notificationSettings || {}),
          }
        })
        .catch(error => {
          console.error('Hesap ayarları için kullanıcı profili alınamadı:', error)
        })
    },
    saveProfile() {
      if (!this.profileForm.firstName || !this.profileForm.lastName || !this.profileForm.birthDate) {
        this.showMessage('Ad, soyad ve doğum tarihi zorunlu alanlar.', 'warning')

        return
      }

      this.profileSaving = true

      axios
        .put(`${process.env.VUE_APP_BASE_API_URL}user/profile`, {
          name: this.profileForm.firstName.trim(),
          surname: this.profileForm.lastName.trim(),
          birthDate: this.formatApiDate(this.profileForm.birthDate),
          gender: this.profileForm.gender,
          email: this.profileForm.email.trim(),
          phoneNumber: this.normalizePhone(this.profileForm.phoneNumber),
          appsFlayerId: this.profileForm.appsFlyerId.trim() || null,
        }, {
          headers: this.authHeaders(),
        })
        .then(response => {
          this.showMessage(response.data?.message || 'Profil bilgileri güncellendi.', 'success')
          this.fetchSelf()
        })
        .catch(error => {
          this.showMessage(this.resolveErrorMessage(error, 'Profil güncellemesi başarısız oldu.'), 'error')
        })
        .finally(() => {
          this.profileSaving = false
        })
    },
    saveNotifications() {
      this.notificationSaving = true

      axios
        .post(`${process.env.VUE_APP_BASE_API_URL}user/notification`, {
          newCampaign: this.notificationForm.newCampaign,
          newBrand: this.notificationForm.newBrand,
          newConversion: this.notificationForm.newConversion,
          newClick: this.notificationForm.newClick,
          newPayout: this.notificationForm.newPayout,
          smartPush: this.notificationForm.smartPush,
        }, {
          headers: this.authHeaders(),
        })
        .then(response => {
          this.showMessage(response.data?.message || 'Bildirim tercihleri güncellendi.', 'success')
        })
        .catch(error => {
          this.showMessage(this.resolveErrorMessage(error, 'Bildirim tercihleri kaydedilemedi.'), 'error')
        })
        .finally(() => {
          this.notificationSaving = false
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.settings-profile__hero {
  display: flex;
  align-items: center;
  gap: 20px;
}

.settings-profile__copy {
  display: flex;
  flex-direction: column;
}

.settings-notification-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 18px 0;
  border-top: 1px solid rgba(148, 163, 184, 0.12);
}

.settings-notification-row:first-child {
  border-top: 0;
  padding-top: 0;
}

@media (max-width: 960px) {
  .settings-profile__hero,
  .settings-notification-row {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
